/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { SectionContainerProps } from '../../../types/InputComponentProps';
import { SimpleGrid, VStack, HStack } from 'chakra-v3';
import { Text, Stepper } from '../../../../../components/Index';

export function SectionContainer(props: SectionContainerProps) {
  const { label, description, children, index, isLast, showStepper } = props;
  const sectionNumber = index !== undefined ? index + 1 : undefined;
  const shouldShowStepper = showStepper && sectionNumber !== undefined;
  const showConnector = shouldShowStepper && !isLast;

  return (
    <VStack alignItems="flex-start" marginBottom="10px" position="relative" data-section-container>
      <HStack gap="18px" alignItems="center">
        {shouldShowStepper && <Stepper number={sectionNumber} showConnector={showConnector} />}
        <VStack alignItems="flex-start" gap={0} flex={1}>
          <Text variant="body" fontSize="16px" fontWeight={600} color="text.primary">
            {label}
          </Text>
          {description && (
            <Text variant="body" fontSize="sm" color="text.primary" opacity={0.8} mt={0}>
              {description}
            </Text>
          )}
        </VStack>
      </HStack>
      <SimpleGrid
        columns={{ sm: 1 }}
        gap={15}
        alignSelf="stretch"
        justifyContent="start"
        ml={shouldShowStepper ? '58px' : '0'}
        mt={shouldShowStepper ? '24px' : '0'}
      >
        {children}
      </SimpleGrid>
    </VStack>
  );
}
